import * as Yup from "yup";
import * as ValidationTemplate from "../../utils/ValidationTemplate";
import CredentialType from "../CredentialType";

export default class Credential {

  constructor(jsonResponse) {

    this.id = jsonResponse["id"];
    this.username = jsonResponse["username"];
    this.password = "";
    this.credentialType = jsonResponse["credential-type"];
    this.active = jsonResponse["active"];
    this.deleted = jsonResponse["deleted"];
  }

  static toJson = function (obj) {
    let jsonObj = {};
    jsonObj["id"] = obj.id;
    jsonObj["username"] = obj.username;
    jsonObj["credential-type"] = obj.credentialType;
    jsonObj["password"] = obj.password;
    jsonObj["active"] = obj.active;
    jsonObj["deleted"] = obj.deleted;
    return jsonObj;
  };

  static getValidationConfig = function () {
    return [
      {
        dataField: "id", dataLabel: "Credential Id",
        hideOnCreate: true, createValue: 0,
        readOnly:true,
        yup: Yup.string()
          .required('Id is required')
      },
      {
        dataField: "credentialType", dataLabel: "Credential Type", hideOnCreate: true,
        readOnly:true,
        // yup: Yup.string()
        //   .required('Credential Type is required')
      },
      {
        dataField: "username", dataLabel: "Username",
        yup: Yup.string()
          .required('Username is required')
          .matches(/^\S*$/, 'No spaces are allowed')
          .min(3, "Username must be at least 3 characters")
      },
      ValidationTemplate.getStandardActiveValidation(),
      ValidationTemplate.getStandardDeleteValidation(),
    ]
  };

  static getValidationConfigForEdit = function (userHasElevatedEditPrivilege = true) {
    return [
      {
        dataField: "id", dataLabel: "Credential Id",
        hideOnCreate: true, createValue: 0,
        readOnly:true,
        yup: Yup.string()
          .required('Id is required')
      },
      {
        dataField: "credentialType", dataLabel: "Credential Type",
        readOnly:true,
        // yup: Yup.string()
        //   .required('Credential Type is required')
      },
      {
        dataField: "username", dataLabel: "Username",
        readOnly: !userHasElevatedEditPrivilege,
        yup: Yup.string()
          .required('Username is required')
          .matches(/^\S*$/, 'No spaces are allowed')
          .min(3, "Username must be at least 3 characters")
      },
      {
        dataField: "active", dataLabel: "Active", hideOnCreate: true, createValue: true, readOnly: false,
        type: "select", selectOptions: [{value: "true", text: "Active"}, {value: "false", text: "Deactivated"}],
        yup: Yup.string()
          .required("Active must have a value set")
      },
      {
        dataField: "deleted", dataLabel: "Deleted",
        hideOnCreate: true, createValue: true, readOnly: false,
        type: "select",
        selectOptions: [{value: "false", text: "Not Deleted"}, {value: "true", text: "Deleted"}],
        yup: Yup.string()
          .required("Deleted must have a value set")
      },
    ]
  };
  static getValidationConfigWithPassword = function (credentialType) {
    if (credentialType === undefined) return null;
    let config = [
      {
        dataField: "id", dataLabel: "Credential Id",
        hideOnCreate: true, createValue: 0,
        yup: Yup.string()
          .required('Id is required')
      },
      {
        dataField: "credentialType", dataLabel: "Credential Type",
        hideOnCreate: true, createValue: credentialType,
        // yup: Yup.string()
          // .required('Credential Type is required')
      },
      {
        dataField: "username", dataLabel: "Username",
        yup: Yup.string()
          .required('Username is required')
          .min(3, "Username must be at least 3 characters")
      },
      {
        dataField: "password", dataLabel: "Password", type: "password",addButton:true,
        yup: Yup.string()
          .required('Password is required')
          .min(5, "Password must be at least 5 characters")
      },
      {
        dataField: "passwordConfirm", dataLabel: "Confirm Password", type: "password",
        yupMatch: 'password',
        yup: Yup.string()
          .required('Password is required')
          .min(5, "Password must be at least 5 characters")
      },
      {
        dataField: "active", dataLabel: "Active", hideOnCreate: true, createValue: true, readOnly: false,
        type: "select", selectOptions: [{value: "true", text: "Active"}, {value: "false", text: "Deactivated"}],
        yup: Yup.string()
          .required("Active must have a value set")
      },
      {
        dataField: "deleted", dataLabel: "Deleted",
        hideOnCreate: true, createValue: false, readOnly: false,
        type: "select",
        selectOptions: [{value: "false", text: "Not Deleted"}, {value: "true", text: "Deleted"}],
        yup: Yup.string()
          .required("Deleted must have a value set")
      },
    ];

    if(credentialType === CredentialType.USER){
      config.push({
        dataField: "expirePassword",
        dataLabel: "Force Password Reset",
        type: "select",
        selectOptions: [{value: true, text: "Yes"}, {value: false, text: "No"}],
        yup: Yup.string()
          .required("Force Password Reset is required ")
      })
    }
    return config;
  };
}



// WEBPACK FOOTER //
// ./src/domain/admin/Credential.js